class PhoneInput extends HTMLElement {
  hiddenInput = 'phone_full';
  iti = null;
  telInput = null;
  #paddingObserver = null;
  constructor() {
    super();
    this.hiddenInput = this.dataset?.hiddenInput || 'phone_full';
  }

  connectedCallback() {
    this.init();
    this.setupListener();
  }

  init() {
    const input = this.querySelector('input');
    this.telInput = input;
    this.classList.add('phone-input-loading');

    const hiddenInput = {
      phone: this.hiddenInput,
    };

    this.iti = window.intlTelInput(input, {
      loadUtils: () =>
        import('https://cdn.jsdelivr.net/npm/intl-tel-input@26.0.6/build/js/utils.js'),
      autoPlaceholder: 'aggressive',
      separateDialCode: true,
      hiddenInput: () => hiddenInput,
      customPlaceholder: (selectedCountryPlaceholder, selectedCountryData) =>
        this.maskPhoneNumber(selectedCountryPlaceholder),
      initialCountry: 'auto',
      geoIpLookup: (success, failure) => {
        fetch('https://ipapi.co/json')
          .then((res) => res.json())
          .then((data) => success(data.country_code))
          .catch(() => failure());
      },
    });

    this.updateEmptyState();

    this.iti?.promise?.then(() => {
      this.updateEmptyState();
      this.classList.remove('phone-input-loading');

      this.#setupPaddingObservers();
    });
  }

  maskPhoneNumber(phone) {
    return phone.slice(0, 1) + '*'.repeat(phone.length - 2);
  }

  getPhoneNumber(format) {
    return this.iti?.getNumber(format);
  }

  updateEmptyState() {
    const input = this.telInput || this.querySelector("input[type='tel']");

    if (!input) return;

    const isEmpty = !input.value.trim();
    this.classList.toggle('phone-input-empty', isEmpty);
    this.classList.toggle('phone-input-has-value', !isEmpty);

    const selectedCountryPrimary = this.querySelector(
      '.iti__selected-country-primary',
    );
    const selectedDialCode = this.querySelector('.iti__selected-dial-code');
    const arrow = this.querySelector('.iti__arrow');

    if (selectedCountryPrimary) {
      selectedCountryPrimary.style.borderRight = isEmpty
        ? 'none'
        : '0.5px solid var(--color-border)';
    }

    if (selectedDialCode) {
      selectedDialCode.style.display = isEmpty ? 'none' : '';
    }

    if (arrow) {
      arrow.style.display = isEmpty ? 'none' : '';
    }

    if (isEmpty) {
      input.placeholder = '';
    }

    const countryContainer = this.querySelector('.iti__country-container');
    if (countryContainer) {
      this.#updateInputPadding(input, countryContainer);
    }
  }

  setupListener() {
    const input = this.querySelector("input[type='tel']");

    if (input) {
      input.addEventListener('focus', (e) => {
        this.updateEmptyState();

        if (!input.value.trim()) return;

        const itlSelectedCountry = this.querySelector(
          '.iti__selected-country-primary',
        );
        if (itlSelectedCountry) {
          itlSelectedCountry.style.borderRight =
            '0.5px solid var(--color-heading)';
        }
      });

      input.addEventListener('focusout', (e) => {
        this.updateEmptyState();

        const itlSelectedCountry = this.querySelector(
          '.iti__selected-country-primary',
        );
        if (itlSelectedCountry && input.value.trim()) {
          itlSelectedCountry.style.borderRight =
            '0.5px solid var(--color-border)';
        }
      });

      input.addEventListener('input', () => {
        this.updateEmptyState();
      });

      input.addEventListener('countrychange', () => {
        this.updateEmptyState();
      });
    }
  }
  #setupPaddingObservers() {
    const input = this.telInput;
    const countryContainer = this.querySelector('.iti__country-container');

    if (!countryContainer || !input) return;

    // MutationObserver — fires when child nodes/attributes change inside the container
    this.#paddingObserver = new MutationObserver(() => {
      this.#updateInputPadding(input, countryContainer);
    });
    this.#paddingObserver.observe(countryContainer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class'],
    });

    // Run once immediately to cover the case where it's already rendered
    this.#updateInputPadding(input, countryContainer);
  }

  #updateInputPadding(input, countryContainer) {
    const width = countryContainer.offsetWidth;
    if (width === 0) return;
    input.style.paddingLeft = `${width + 6}px`;
  }
}

customElements.define('phone-input', PhoneInput);
